"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./styles.module.scss";
import { Autoplay, Pagination } from "swiper/modules";
import strapiSingleAttribute from "@/api/strapiSingleAttribute";
import Button from "@/components/atoms/Button";
import Markdown from "@/components/atoms/Markdown";
import cn from "clsx";
import { useRouter } from "next/navigation";

export default function ListingBanner({
  Banner,
  isDesktop,
  isNewsList = false,
}) {
  return (
    <div className="container">
      <Swiper
        autoplay={{
          delay: 6000,
        }}
        modules={[Pagination, Autoplay]}
        spaceBetween={8}
        slidesPerView={1}
        pagination={{ clickable: true }}
        className={cn(
          "Carousel__hAuto Carousel__white_left_dot",
          styles.carousel
        )}
        id="blogs-listing-banner"
      >
        {Banner?.filter((x) => x?.enabled)?.map((item, i) => (
          <SwiperSlide key={i}>
            <BannerCard
              {...item}
              isDesktop={isDesktop}
              isNewsList={isNewsList}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}

export function BannerCard({
  Image,
  Date,
  ReadingTimeText,
  NewsSource = null,
  Heading,
  CTA,
  isDesktop,
  isSingleBlog = false,
  isNewsList = false,
}) {
  const img = strapiSingleAttribute(
    isDesktop ? Image?.source : Image?.mobileSource
  );
  const router = useRouter();
  return (
    <div className={styles.imageContainer}>
      <img src={img?.url} alt={Image?.alt ||''} className={styles.image} />
      {isSingleBlog ? (
        <img
          src="/_a/icons/left-arrow-white-circle.svg"
          alt="go back"
          onClick={() => router.push("/amity/blog")}
          className={styles.backButton}
        />
      ) : null}
      <div
        className={cn(styles.textContainer, {
          [styles.singleBlogTextContainer]: isSingleBlog,
        })}
      >
       <div
          className={(isNewsList && Date) && cn(styles.dateContainer, {
            [styles.dateContainerNewsList]: isNewsList,
          })}
        >
          <span>{Date}</span>
           <span
            className={cn({
              ["block lg:inline"]: isNewsList,
            })}
          >
            {isNewsList ? NewsSource : ReadingTimeText}
          </span>
        </div>
        {Heading?.enabled ? (
          <h1><Markdown className={styles.heading}>{Heading?.text}</Markdown></h1>
        ) : null}
        {CTA?.enabled ? (
          <Button
            buttonProps={{
              href: CTA?.url || "#",
              target: CTA?.target?.[0] || "_self",
            }}
            icon="/_a/icons/left-arrow-white.svg"
            hoverIcon="/_a/icons/left-arrow.svg"
            bg="o"
            color="w"
          >
            {CTA?.text}
          </Button>
        ) : null}
      </div>
    </div>
  );
}
